"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = finalizeCartOutputPrices;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));

var _isObjectLike = _interopRequireDefault(require("lodash/fp/isObjectLike"));

var _flattenCartContent = _interopRequireDefault(require("./flattenCartContent"));

var calcTotal = function calcTotal(price, quantity, numberOfRepeats, fixedPrice) {
  return (price || 0) * (fixedPrice ? 1 : quantity || 0) * (numberOfRepeats || 1);
};

var pfmc = function pfmc(currency, pr) {
  return pr === undefined ? 0 : (pr.find(function (p) {
    return p.currency === currency;
  }) || {}).amount || 0;
};

var findVatValue = function findVatValue(region, currency, taxes, listPrice, listPriceWithTax) {
  var resolveTaxValue = function resolveTaxValue(txv) {
    if (typeof txv === 'number') return txv;
    throw new Error('VAT value as of type `PricingProductTaxValueTuple` is not supported');
  };

  var toTaxInfo = function toTaxInfo(v, code, taxGroup) {
    return {
      amount: 0,
      code: code,
      taxGroup: taxGroup,
      value: v,
      mlt: 1 + v,
      totalTaxed: 0
    };
  };

  var lpt = listPrice ? pfmc(currency, listPrice) : pfmc(currency, listPriceWithTax) || 0;
  var lpwt = listPriceWithTax ? pfmc(currency, listPriceWithTax) : pfmc(currency, listPrice) || 0;
  return (0, _pipe.default)(function (txs) {
    return txs ? txs.find(function (tx) {
      return tx.taxGroup.toLowerCase() === 'vat' && tx.region === region;
    }) : undefined;
  }, function (x) {
    return x ? toTaxInfo(resolveTaxValue(x.value), x.code, x.taxGroup) : undefined;
  }, function (x) {
    return x === undefined ? (0, _pipe.default)(function (v) {
      return Math.round(v * 100) / 100;
    }, function (v) {
      return v > 0 ? v - 1 : 0;
    }, function (v) {
      return toTaxInfo(v, "vat".concat(v * 100), 'vat');
    })(lpwt / (lpt || 1)) : x;
  })(taxes);
};

function finalizeCartOutputPrices(res) {
  var _res = (0, _slicedToArray2.default)(res, 3),
      err = _res[0],
      prevCtx = _res[1],
      log = _res[2];

  var currency = prevCtx.currency,
      decimalPrecision = prevCtx.decimalPrecision,
      pricesType = prevCtx.pricesType,
      region = prevCtx.region;
  var prettyPrecision = Array(decimalPrecision).fill(1).reduce(function (a) {
    return a * 10;
  }, 1);

  var makePretty = function makePretty(n) {
    return n === undefined ? undefined : Math.round(n * prettyPrecision) / prettyPrecision;
  };

  var calcSubjectPrices = function calcSubjectPrices(subject) {
    var priceUgly = subject.price,
        priceOriginalUgly = subject.priceOriginal,
        product = subject.product;

    var _ref = (0, _isObjectLike.default)(product) ? product : {},
        listPrice = _ref.listPrice,
        listPriceWithTax = _ref.listPriceWithTax,
        taxes = _ref.taxes;

    var taxInfo = findVatValue(region, currency, taxes, listPrice, listPriceWithTax);
    return (0, _pipe.default)(function () {
      var safeDiscount = function safeDiscount(n) {
        return n === 0 ? undefined : n;
      };

      var price = makePretty(priceUgly) || 0;
      var priceOriginal = makePretty(priceOriginalUgly);
      var discountAbsolute = priceOriginal ? safeDiscount(makePretty(priceOriginal - price)) : undefined;

      if (discountAbsolute !== undefined) {
        var discountPercent = discountAbsolute / priceOriginal;
        return {
          discountAbsolute: discountAbsolute,
          discountPercent: discountPercent,
          price: price,
          priceOriginal: priceOriginal
        };
      }

      return {
        discountAbsolute: undefined,
        discountPercent: undefined,
        price: price,
        priceOriginal: undefined
      };
    }, function (z) {
      switch (pricesType) {
        case 'B2B':
          return (0, _extends2.default)({}, z, {
            price: z.price,
            priceOriginal: z.priceOriginal,
            priceWithTax: z.price * taxInfo.mlt,
            priceOriginalWithTax: z.priceOriginal === undefined ? undefined : z.priceOriginal * taxInfo.mlt
          });

        case 'B2BForeign':
          return (0, _extends2.default)({}, z, {
            price: z.price,
            priceOriginal: z.priceOriginal,
            priceWithTax: undefined,
            priceOriginalWithTax: undefined
          });

        case 'B2C':
        default:
          return (0, _extends2.default)({}, z, {
            price: z.price / taxInfo.mlt,
            priceOriginal: z.priceOriginal === undefined ? undefined : z.priceOriginal / taxInfo.mlt,
            priceWithTax: z.price,
            priceOriginalWithTax: z.priceOriginal
          });
      }
    }, function (z) {
      return (0, _extends2.default)({}, z, {
        taxInfo: (0, _extends2.default)({}, taxInfo, {
          amount: calcTotal((z.priceWithTax || z.price) - z.price, subject.quantity, subject.numberOfRepeats),
          totalTaxed: calcTotal(z.price, subject.quantity, subject.numberOfRepeats)
        })
      });
    }, function (z) {
      return (0, _extends2.default)({}, subject, z);
    })();
  };

  var calcSubjectPricesInclIndirect = function calcSubjectPricesInclIndirect(subject) {
    return function (ns) {
      return (0, _extends2.default)({}, ns, {
        indirectSubjects: (ns.indirectSubjects || []).map(calcSubjectPrices)
      });
    }(calcSubjectPrices(subject));
  };

  var nextCart = (0, _pipe.default)(function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      indirectSubjects: (xcart.indirectSubjects || []).map(calcSubjectPrices),
      payment: calcSubjectPricesInclIndirect(xcart.payment),
      shipping: calcSubjectPricesInclIndirect(xcart.shipping),
      subjects: (xcart.subjects || []).map(calcSubjectPricesInclIndirect)
    });
  }, // Recalculate totals...
  function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      indirectSubjects: (xcart.indirectSubjects || []).map(function (s) {
        return (0, _extends2.default)({}, s, {
          subjectTotal: calcTotal(s.price, s.quantity, s.numberOfRepeats, s.fixedPrice),
          subjectTotalWithTax: calcTotal(s.priceWithTax || s.price, s.quantity, s.numberOfRepeats, s.fixedPrice)
        });
      }),
      payment: (0, _extends2.default)({}, xcart.payment, {
        subjectTotal: function (pm) {
          return calcTotal(pm.price || 0, pm.quantity || 1, pm.numberOfRepeats, pm.fixedPrice);
        }(xcart.payment || {}),
        subjectTotalWithTax: function (pm) {
          return calcTotal(pm.priceWithTax || 0, pm.quantity || 1, pm.numberOfRepeats, pm.fixedPrice);
        }(xcart.payment || {})
      }),
      shipping: (0, _extends2.default)({}, xcart.shipping, {
        subjectTotal: function (sp) {
          return calcTotal(sp.price || 0, sp.quantity || 1, sp.numberOfRepeats, sp.fixedPrice);
        }(xcart.shipping || {}),
        subjectTotalWithTax: function (sp) {
          return calcTotal(sp.priceWithTax || 0, sp.quantity || 1, sp.numberOfRepeats, sp.fixedPrice);
        }(xcart.shipping || {})
      }),
      subjects: (xcart.subjects || []).map(function (s) {
        return (0, _extends2.default)({}, s, s.indirectSubjects ? {
          indirectSubjects: s.indirectSubjects.map(function (is) {
            const priceWithTaxPromoCode =
              is.product &&
                is.product.sku &&
                is.product.sku.includes("PROMO_%_")
                ?  Math.floor(
                  calcTotal(
                  s.priceWithTax * (1 - (is.product.sku.replace("PROMO_%_", "") / 100 || 0)) - s.priceWithTax,
                  is.deleted ? 0 : s.quantity,
                  is.numberOfRepeats,
                  is.fixedPrice
                ))
                : calcTotal(is.priceWithTax || is.price, is.deleted ? 0 : is.quantity, is.numberOfRepeats, is.fixedPrice);
            const pricePromoCode = priceWithTaxPromoCode / s.taxInfo.mlt;
            return (0, _extends2.default)({}, is, {
              ...(is.product &&
                is.product.sku &&
                is.product.sku.includes("PROMO_%_")
                ? {
                  price: pricePromoCode,
                  priceWithTax: priceWithTaxPromoCode,
                  subjectTotal: pricePromoCode,
                  subjectTotalWithTax: priceWithTaxPromoCode,
                  taxInfo: {
                    amount: priceWithTaxPromoCode - pricePromoCode,
                    code: s.taxInfo.code,
                    taxGroup: "vat",
                    value: s.taxInfo.value,
                    mlt: s.taxInfo.mlt,
                    totalTaxed: pricePromoCode,
                  },
                  taxes: s.taxes
                }
                : {
                  subjectTotal: calcTotal(is.price, is.deleted ? 0 : is.quantity, is.numberOfRepeats, is.fixedPrice),
                  subjectTotalWithTax: calcTotal(is.priceWithTax || is.price, is.deleted ? 0 : is.quantity, is.numberOfRepeats, is.fixedPrice)
                }),
            });
          })
        } : {}, {
          subjectTotal: calcTotal(s.price, s.quantity, s.numberOfRepeats, s.fixedPrice),
          subjectTotalWithTax: calcTotal(s.priceWithTax || s.price, s.quantity, s.numberOfRepeats, s.fixedPrice)
        });
      })
    });
  }, function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      totalSubjects: xcart.indirectSubjects.reduce(function (t, s) {
        return t + s.subjectTotal;
      }, 0) + xcart.subjects.reduce(function (t, s) {
        return t + s.subjectTotal + (s.indirectSubjects || []).reduce(function (isr, is) {
          return isr + is.subjectTotal;
        }, 0);
      }, 0),
      totalSubjectsWithTax: xcart.indirectSubjects.reduce(function (t, s) {
        return t + s.subjectTotalWithTax;
      }, 0) + xcart.subjects.reduce(function (t, s) {
        return t + s.subjectTotalWithTax + (s.indirectSubjects || []).reduce(function (isr, is) {
          return isr + is.subjectTotalWithTax;
        }, 0);
      }, 0)
    });
  }, function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      total: xcart.totalSubjects + xcart.payment.subjectTotal + xcart.shipping.subjectTotal,
      totalWithTax: xcart.totalSubjectsWithTax + xcart.payment.subjectTotalWithTax + xcart.shipping.subjectTotalWithTax
    });
  }, function (xcart) {
    return (0, _extends2.default)({}, xcart, {
      taxesSummary: (0, _pipe.default)(_flattenCartContent.default, function (fl) {
        return fl.reduce(function (a, s) {
          var taxInfo = s.taxInfo;
          if (!taxInfo) return a;
          var idx = a.findIndex(function (i) {
            return i.code === taxInfo.code;
          });

          if (idx === -1) {
            return [].concat((0, _toConsumableArray2.default)(a), [{
              amount: taxInfo.amount,
              code: taxInfo.code,
              taxGroup: taxInfo.taxGroup,
              totalTaxed: taxInfo.totalTaxed
            }]);
          }

          var next = (0, _toConsumableArray2.default)(a);
          next[idx].amount += taxInfo.amount;
          next[idx].totalTaxed += taxInfo.totalTaxed;
          return next;
        }, []);
      }, function (detail) {
        return {
          detail: detail,
          totalTaxAmount: detail.reduce(function (a, s) {
            return a + s.amount;
          }, 0),
          totalTaxed: detail.reduce(function (a, s) {
            return a + s.totalTaxed;
          }, 0)
        };
      })(xcart)
    });
  })(prevCtx.cart);
  var ctx = (0, _extends2.default)({}, prevCtx, {
    cart: nextCart
  });
  return [err, ctx, log];
}